import { ActionReducerMap } from '@ngrx/store';

import * as menuAction from './org-admin-settings.actions';
import { IMenu } from '../interfaces';
import { IReportTemplateState, reportTemplateReducer } from '../../report-template/store/report-template.reducer';
import { INavigationConfigurationInterface } from '@ispm/navigation/interfaces';

export interface IMenuState {
  menu: Array<IMenu>;
  globalMenu: Array<IMenu>;
  selected: string;
}

export interface IState {
  navigation: IMenuState;
  reportTemplates: IReportTemplateState;
  applications: Array<any>;
  configuration: INavigationConfigurationInterface;
}

export const reducers: ActionReducerMap<IState> = {
  navigation: menuReducer,
  reportTemplates: reportTemplateReducer,
  applications: appReducer,
  configuration: configurationReducer,
};

export const getMenus = (state: IState) => {
  return state.navigation.menu;
};

export const getGlobalMenus = (state: IState) => {
  return state.navigation.globalMenu;
};

export const getSelected = (state: IState ) => {
  return state.navigation.selected;
};

export const getConfiguration = (state: IState ) => {
  return state.configuration;
};

export const menuInitialState: IMenuState = {
  menu: [],
  globalMenu: [],
  selected: null
};

export function menuReducer(state: IMenuState = menuInitialState, action: menuAction.StoreAction) {
  switch (action.type) {
    case menuAction.MENU_INIT: {
      return Object.assign({ }, state, action.payload);
    }
    case menuAction.MENU_SELECT: {
      return {
        ...state,
        selected: action.payload,
      };
    }
    default:
      return state;
  }
}

export function appReducer(state: any = [], action: menuAction.StoreAction) {
  switch (action.type) {
    case menuAction.APPS_INIT: {
      return Object.assign({ }, state, action.payload);
    }
    default:
      return state;
  }
}

export function configurationReducer(state: any = {}, action: menuAction.StoreAction) {
  switch (action.type) {
    case menuAction.CONFIGURATION_INIT: {
      return Object.assign({ }, state, action.payload);
    }
    default:
      return state;
  }
}
